import React from "react";
import DivideMatchesContainer from "../../containers/schedule/DivideMatchesContainer";
import { Typography } from "@material-ui/core";
import { languages } from "../../constants/languages";

function PlannerCard(props) {
  return (
    <div
      style={{ padding: 10, overflowY: "auto", height: "calc(100vh - 132px)" }}
    >
      <Typography variant="h6">{languages.schedule.plan}</Typography>

      {props.divisions.length > 0 && props.matchesLoaded && (
        <div style={{ marginTop: 10 }}>
          <DivideMatchesContainer {...props} />
        </div>
      )}
    </div>
  );
}

export default PlannerCard;
